import { render, staticRenderFns } from "./odometro.vue?vue&type=template&id=d23b7e4a&"
import script from "./odometro.vue?vue&type=script&lang=js&"
export * from "./odometro.vue?vue&type=script&lang=js&"
import style0 from "./odometro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports